// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { UserRole } from '../app/shared/auth.roles';

export const environment = {
  production: false,
  buyUrl : 'https://1.envato.market/6NV1b',
  SCARF_ANALYTICS : false,
  adminRoot: '/APP',
  errorRoot: '/APP/blank-page',
  loginURL: '/user/login',
  // live
  // apiUrl:  'https://api-fmis.bizsoft.app/api/',
  // "api-fmis": "https://api-fmis.bizsoft.app/api/",
  // apiURL: "https://api-fmis.bizsoft.app/api/",

  // local
  apiUrl:  'https://localhost:44384/api/',
  "api-fmis": "https://localhost:44384/api/",
  apiURL: "https://localhost:44384/api/",
  
  //apiUrl:  'https://localhost:44384/api/',
  //apiUrl:  'https://localhost:44375/api/',
  //Report Local
  // apiUrl:  'http://localhost:4101/api/',
  defaultMenuType: 'menu-default',
  subHiddenBreakpoint: 1440,
  menuHiddenBreakpoint: 768,
  themeColorStorageKey: 'vien-themecolor',
  isMultiColorActive: true,
  token: "",
  defaultColor: 'light.blueyale',
  isDarkSwitchActive: true,
  defaultDirection: 'ltr',
  themeRadiusStorageKey: 'vien-themeradius',
  isAuthGuardActive: true,
  defaultRole: UserRole.Admin,
  firebase: {
    apiKey: 'AIzaSyCqoNLB_jTw4nncO12qR-eDH9gAeWiZVaw',
    authDomain: 'vien-angular-login.firebaseapp.com',
    databaseURL: 'https://vien-angular-login.firebaseio.com',
    projectId: 'vien-angular-login',
    storageBucket: 'vien-angular-login.appspot.com',
    messagingSenderId: '16217062888',
    appId: '1:16217062888:web:6b08232ca0c9662fedb85d',
    measurementId: 'G-8ETT79WRRN'
  }
};
